module.exports = __webpack_public_path__ + "img/8.9dd5e00b.jpg";